import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpaceTypesList } from '../../../Pages/SpaceTypes/ISpaceTypes';

export const AddSpaceTypesSlicer = createSlice({
  name: 'AddSpaceTypes',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISpaceTypesList>,
  reducers: {
    addSpaceTypes: (state, _) => {
      state.isLoading = true;
    },
    successAddSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddSpaceTypesState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSpaceTypes,
  failureAddSpaceTypes,
  successAddSpaceTypes,
  clearAddSpaceTypesState,
} = AddSpaceTypesSlicer.actions;

export default AddSpaceTypesSlicer.reducer;
